import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { AccumulatorEdit } from 'src/app/accumulator/model/accumulatorEdit';
import { AccumulatorList } from 'src/app/accumulator/model/accumulatorList';
import { CacheBuster } from 'ts-cacheable';

const accumulatorsCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class AccumulatorService implements OnDestroy
{
  private messagingLanguageChangedSubscription: Subscription;

  constructor(private http: HttpClient) { }

  /**
   * Delete a Accumulator.
   *
   * @param id Accumulator id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: accumulatorsCacheBuster
    })
  public deleteAccumulator(id: number): Observable<AccumulatorList>
  {
    return this.http.delete<AccumulatorList>(`/accumulator/${id}`);
  }

  /**
   * Save a Accumulator.
   *
   * @param data Accumulator to persit
   * @param isNew Indicate if this is a new or update
   */
  @CacheBuster(
    {
      cacheBusterNotifier: accumulatorsCacheBuster
    })
  public saveAccumulator(data: any, isNew: boolean, accumulatorId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/accumulator', data);
    }
    else
    {
      return this.http.put(`/accumulator/${accumulatorId}`, data);
    }
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get Accumulator for grid list.
   */
  public getAccumulatorList(): Observable<AccumulatorList[]>
  {
    return this.http.get<AccumulatorList[]>('/accumulator/list');
  }

  /**
   * Get Accumulator by id.
   *
   * @param id Accumulator id
   */
  public getAccumulatorById(id: number): Observable<AccumulatorEdit>
  {
    return this.http.get<AccumulatorEdit>(`/accumulator/${id}`);
  }

  /**
   * Check if Accumulator is in use
   *
   * @param id Accumulator Id
   */
  public existsAccumulator(id: number): Observable<any>
  {
    return this.http.get(`/accumulator/inuse/${id}`);
  }

  /**
   * Check if Accumulator Name exists to avoid name duplicates
   *
   * @param name Accumulator Name
   */
  public existsAccumulatorName(name: string): Observable<any>
  {
    return this.http.get(`/accumulator/exists?name=${name}`);
  }
}
